/*
 * assets/js/src/dock.js — plovoucí CTA vpravo dole.
 *
 * Návrh to řeší dvěma třídami na `<body>`: `scrolled` (po 500 px) a
 * `cta-visible` (když je vidět formulář nebo patička). `scrolled` ale
 * obsluhuje legacy `scrollMenu` v mirrorovaném `main.js` — psát do cizí
 * třídy znamená měnit chování, které neovládáme. Stav proto nese sám dock
 * ve třídě `vyjety`.
 *
 * DVĚ PODMÍNKY, OBĚ MUSÍ PLATIT:
 *   1. návštěvník odroloval (práh níž),
 *   2. na obrazovce není formulář ani patička — tam už výzva je a dock
 *      by ji překrýval.
 *
 * Bez skriptu se dock neukáže vůbec (`display: none` v CSS). Je to
 * zkratka k akci, ne jediná cesta k ní: telefon je v hlavičce a formulář
 * na stránce níž.
 */

const PRAH = 500;

export function init() {
	const dock = document.querySelector('.dock');
	if (!dock) return 0;

	/*
	 * Cil kotvy musi existovat, jinak by tlacitko slibovalo skok nikam.
	 * Drive se v takovem pripade tlacitko smazalo — jenze pak mel dock
	 * na nekterych strankach jen telefon a na jinych oboji (majitel
	 * 17. 9.: „to vyjizdeci bocni cta by melo byt vsude stejne").
	 * Spravne je poslat vyzvu na Kontakt; adresu dodava PHP v atributu,
	 * protoze skript ji sam nezjisti. Smaze se jen tehdy, kdyz neni ani
	 * kotva, ani nahrada.
	 */
	const cta = dock.querySelector('.dock-cta');
	const cil = cta && cta.getAttribute('href');
	if (cil && cil.startsWith('#') && cil.length > 1 && !document.getElementById(cil.slice(1))) {
		const nahrada = dock.getAttribute('data-cta-nahrada');
		if (nahrada) cta.setAttribute('href', nahrada);
		else cta.remove();
	}
	if (!dock.children.length) return 0;

	let odrolovano = false;
	let prekazka = false;

	const prekresli = () => {
		dock.classList.toggle('vyjety', odrolovano && !prekazka);
	};

	const naScroll = () => {
		const nove = window.scrollY > PRAH;
		if (nove === odrolovano) return;
		odrolovano = nove;
		prekresli();
	};

	window.addEventListener('scroll', naScroll, { passive: true });
	naScroll();

	if (window.IntersectionObserver) {
		const videno = new Set();
		const pozorovatel = new window.IntersectionObserver((zaznamy) => {
			for (const z of zaznamy) {
				if (z.isIntersecting) videno.add(z.target);
				else videno.delete(z.target);
			}
			prekazka = videno.size > 0;
			prekresli();
		}, { threshold: 0.12 });

		for (const sel of ['.formsec', 'footer']) {
			const el = document.querySelector(sel);
			if (el) pozorovatel.observe(el);
		}
	}

	return 1;
}
